module.exports = __webpack_public_path__ + "static/img/banner@2x.06753e6d.png";